export default __webpack_public_path__ + "static/media/Loading_2.30feb443.gif";